<template>
  <div class="Hot_wire">
    <el-form :inline="true" style="padding: 15px;" class="demo-form-inline">
      <div style="font-weight: 700;font-size: 18px;padding-bottom:15px">基本情况</div>
      <el-form-item>
        <template slot="label">
          <span><i style="color: red">*</i> 连接工单编号</span>
        </template>
        <el-input v-model="data.workNo" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item>
        <template slot="label">
          <span><i style="color: red">*</i> 来电号码</span>
        </template>
        <!-- <el-input v-model="data.phone" placeholder="来电号码" maxlength="11" show-word-limit></el-input> -->
        <el-autocomplete
          class="inline-input"
          v-model="data.phone"
          show-word-limit
          :fetch-suggestions="querySearch"
          :trigger-on-focus="false"
          @select="handleSelect"
          :disabled="true"
        >
        <template slot-scope="{ item }">
          <div class="name">{{ item.Phone + '(' + item.RealName + ')' }}</div>
        </template>
      </el-autocomplete>
      </el-form-item>
      <el-form-item label="省份">
        <el-input v-model="data.province" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="城市">
        <el-input v-model="data.city" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="发生日期">
        <el-date-picker
          style="width: 202px;"
          v-model="data.happenDate"
          type="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          :disabled="true">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="次数">
        <el-input v-model="data.times" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="是否为危机个案">
        <el-input v-model="data.isCrisis" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="危机编号">
        <el-input v-model="data.crisiNo" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="总时间">
        <el-input v-model="data.totalTime" :disabled="true"></el-input>
      </el-form-item>
      <!-- <el-form-item label="发生日期">
        <el-input v-model="data.a1"></el-input>
      </el-form-item> -->
      <el-form-item label="接线员">
        <el-input v-model="data.operator" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="质量控制">
        <el-input v-model="data.qualityControl" :disabled="true"></el-input>
      </el-form-item>
      <!-- <el-form-item label="发生日期">
        <el-input v-model="data.a1"></el-input>
      </el-form-item> -->
      <el-form-item label="曾用电话1">
        <el-input v-model="data.usedPhoneOne" maxlength="11" show-word-limit :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="曾用电话2">
        <el-input v-model="data.usedPhoneTwo" maxlength="11" show-word-limit :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="曾用电话3">
        <el-input v-model="data.usedPhoneThree" maxlength="11" show-word-limit :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="曾用电话4">
        <el-input v-model="data.usedPhoneFour" maxlength="11" show-word-limit :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="首次工单号">
        <el-input v-model="data.firstWorkNo" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="呼叫编号">
        <el-input v-model="data.callNumber" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="得知本热线">
        <el-input v-model="data.knowHotline" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="专线">
        <el-input v-model="data.dedicatedLine" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="海外来电">
        <el-input v-model="data.overseasCalls" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="按键信息">
        <el-input v-model="data.keyInformation" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="性别">
        <el-input v-model="data.sex" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="年龄">
        <el-input v-model="data.years" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="学历">
        <el-input v-model="data.degree" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="婚姻">
        <el-input v-model="data.marriage" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="主要职业">
        <el-input v-model="data.mainCareer" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="居住状态">
        <el-input v-model="data.residentialStatus" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="来电人员类型">
        <el-input v-model="data.personType" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="data.name" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="培养层次">
        <el-input v-model="data.trainLevel" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="培养单位">
        <el-input v-model="data.trainID" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item>
        <template slot="label">
          <span><i style="color: red">*</i> 学号</span>
        </template>
        <el-input v-model="data.userId" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="年级">
        <el-input v-model="data.entryDate" :disabled="true"></el-input>
      </el-form-item>
      <div style="font-weight: 700;font-size: 18px;padding-bottom:15px">来电主诉</div>
      <el-form-item label="来电类型">
        <el-input v-model="data.callType" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="既往治疗">
        <el-input v-model="data.psychotherapyHistory" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="既往诊断">
        <el-input v-model="data.psychotherapyDescribe" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="现在治疗">
        <el-input v-model="data.psychotherapyNow" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="精神状态">
        <el-input v-model="data.mentality" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="主诉归类">
         <el-input type="textarea" v-model="data.chiefcomplaintType" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="其他标签">
        <el-input type="textarea" v-model="data.otherLabel" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="目前用药">
        <el-input type="textarea" v-model="data.medicationNow" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="风险评估等级">
        <el-input v-model="data.urgentStatus" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="具体内容">
        <el-input type="textarea" v-model="data.detailContent" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="连接工作记录">
        <el-input type="textarea" v-model="data.answerPhoneRecord" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="结束情况">
        <el-input v-model="data.referralEnd" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="转介资源情况1">
        <el-input v-model="data.referralResourcesOne" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="转介资源情况2">
        <el-input v-model="data.referralResourcesTwo" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="转介资源情况3">
        <el-input v-model="data.referralResourcesThree" :disabled="true"></el-input>
      </el-form-item>
      <div style="font-weight: 700;font-size: 18px;padding-bottom:15px">危机评估</div>
      <el-form-item label="自杀他杀类型">
        <el-input v-model="data.killType" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="个人自杀史">
        <el-input v-model="data.ownSuicideHistory" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="个人自杀史描述">
        <el-input v-model="data.ownSuicideDiscribe" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="亲友自杀史">
        <el-input v-model="data.friendSuicideHistory" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="亲友自杀史描述">
        <el-input v-model="data.friendSuicideDiscribe" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="自杀/他杀计划">
        <el-input v-model="data.killPlan" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="自杀/他杀计划细节">
        <el-input v-model="data.killPlanDetail" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="自杀/他杀计划可能性">
        <el-input v-model="data.killFeasibility" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="自杀/他杀计划致命性">
        <el-input v-model="data.killFatality" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="现实压力">
        <el-input v-model="data.realisticPressure" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="社会支持">
        <el-input v-model="data.socialSupport" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="其他保护性资源">
        <el-input v-model="data.protectResources" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="保密突破">
        <el-input v-model="data.secrecyThrough" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="来电者住址">
        <el-input v-model="data.callAddress" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="身份证号">
        <el-input v-model="data.idCard" maxlength="18" show-word-limit :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="紧急联系人">
        <el-input v-model="data.urgentContactName" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="与危机者关系">
        <el-input v-model="data.urgentRelation" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="data.contactPhone" maxlength="11" show-word-limit :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="愿意透露">
        <el-input v-model="data.tellInformation" :disabled="true"></el-input>
      </el-form-item>
      <div style="font-weight: 700;font-size: 18px;padding-bottom:15px">危机详情</div>
      
      <el-form-item label="危机详情" class="qw">
        <el-input type="textarea" v-model="data.crisisDetail" :disabled="true"></el-input>
      </el-form-item>

      <div style="font-weight: 700;font-size: 18px;padding-bottom:15px">热线干预措施</div>

      <el-form-item label="热线干预措施" class="qw">
        <el-input type="textarea" v-model="data.hotLineIntervene" :disabled="true"></el-input>
      </el-form-item>

      <div style="font-weight: 700;font-size: 18px;padding-bottom:15px">联系结果</div>  

      <el-form-item label="编号1">
        <el-input v-model="data.contactNoOne" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="结果1">
        <el-input v-model="data.contactResultsOne" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="编号2">
        <el-input v-model="data.contactNoTwo" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="结果2">
        <el-input v-model="data.contactResultsTwo" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="编号3">
        <el-input v-model="data.contactNoThree" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="结果3">
        <el-input v-model="data.contactResultsThree" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="编号4">
        <el-input v-model="data.contactNoFour" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="结果4">
        <el-input v-model="data.contactResultsFour" :disabled="true"></el-input>
      </el-form-item>

      <div style="font-weight: 700;font-size: 18px;padding-bottom:15px">危机随访者特征</div>

      <el-form-item label="随访情况">
        <el-input v-model="data.followUpType" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="随访者姓名">
        <el-input v-model="data.followUpName" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="与危机者关系">
        <el-input v-model="data.followUpRelation" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="随访电话1">
        <el-input v-model="data.followUpPhoneOne" maxlength="11" show-word-limit :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="随访电话2">
        <el-input v-model="data.followUpPhoneTwo" maxlength="11" show-word-limit :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="危机者姓名">
        <el-input v-model="data.crisisName" :disabled="true"></el-input>
      </el-form-item>

      <h2 style="font-size: 20px;  padding-bottom: 20px" v-if="data.parameter">"五困"类型及具体表现</h2>

      <el-form-item class="difficulty" label="学习困扰" v-if="data.parameter">
        <el-checkbox-group :max="3" v-model="data.parameter.studyDifficulty" :disabled="true">
          <el-checkbox label="1" name="type">学业基础薄弱</el-checkbox>
          <el-checkbox label="2" name="type">学习能力差</el-checkbox>
          <el-checkbox label="3" name="type">科研能力差</el-checkbox>
          <el-checkbox label="4" name="type">缺乏专业兴趣</el-checkbox>
          <el-checkbox label="5" name="type">第一次挂科</el-checkbox>
          <el-checkbox label="6" name="type">多门挂科</el-checkbox>
          <el-checkbox label="7" name="type">缺课缺考</el-checkbox>
          <el-checkbox label="8" name="type">留级延期</el-checkbox>
          <el-form-item label="其他" label-width="60px" style="display: inline-block;">
            <el-input style="width: 200px;" v-model="data.parameter.studyDifficultyOther" maxlength="30" show-word-limit :disabled="true"></el-input>
          </el-form-item>
        </el-checkbox-group>
        
      </el-form-item>

      <el-form-item class="difficulty" label="生活困扰" v-if="data.parameter">
        <el-checkbox-group :max="3" v-model="data.parameter.lifeDifficulty" :disabled="true">
          <el-checkbox label="1" name="type">经济困难</el-checkbox>
          <el-checkbox label="2" name="type">未获助学贷款</el-checkbox>
          <el-checkbox label="3" name="type">家庭重大变故</el-checkbox>
          <el-checkbox label="4" name="type">严重躯体疾病</el-checkbox>
          <el-checkbox label="5" name="type">生活自理困难</el-checkbox>
          <el-checkbox label="6" name="type">身体缺陷</el-checkbox>
          <el-checkbox label="7" name="type">语言困难</el-checkbox>
          <el-checkbox label="8" name="type">被骗被控制</el-checkbox>
          <el-form-item label="其他" label-width="60px" style="display: inline-block;">
            <el-input style="width: 200px;" v-model="data.parameter.lifeDifficultyOther" maxlength="30" show-word-limit :disabled="true"></el-input>
          </el-form-item>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item class="difficulty" label="交往困扰" v-if="data.parameter">
        <el-checkbox-group :max="3" v-model="data.parameter.contactDifficulty" :disabled="true">
          <el-checkbox label="1" name="type">内向孤僻</el-checkbox>
          <el-checkbox label="2" name="type">退缩回避</el-checkbox>
          <el-checkbox label="3" name="type">适应不良</el-checkbox>
          <el-checkbox label="4" name="type">同学关系不良</el-checkbox>
          <el-checkbox label="5" name="type">师生关系不良</el-checkbox>
          <el-checkbox label="6" name="type">亲密关系不良</el-checkbox>
          <el-checkbox label="7" name="type">家庭关系不良</el-checkbox>
          <el-checkbox label="8" name="type">遭遇欺凌等</el-checkbox>
          <el-form-item label="其他" label-width="60px" style="display: inline-block;">
            <el-input style="width: 200px;" v-model="data.parameter.contactDifficultyOther" maxlength="30" show-word-limit :disabled="true"></el-input>
          </el-form-item>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item class="difficulty" label="发展困扰" v-if="data.parameter">
        <el-checkbox-group
          :max="3"
          v-model="data.parameter.developDifficulty"
          :disabled="true"
        >
          <el-checkbox label="1" name="type">深感自卑</el-checkbox>
          <el-checkbox label="2" name="type">思想偏激</el-checkbox>
          <el-checkbox label="3" name="type">发展迷茫</el-checkbox>
          <el-checkbox label="4" name="type">过高期待</el-checkbox>
          <el-checkbox label="5" name="type">毕业困难</el-checkbox>
          <el-checkbox label="6" name="type">考研失败</el-checkbox>
          <el-checkbox label="7" name="type">就业困难</el-checkbox>
          <el-checkbox label="8" name="type">创业失败</el-checkbox>
          <el-form-item label="其他" label-width="60px" style="display: inline-block;">
            <el-input style="width: 200px;" v-model="data.parameter.developDifficultyOther" maxlength="30" show-word-limit :disabled="true"></el-input>
          </el-form-item>
        </el-checkbox-group>
       
      </el-form-item>

      <el-form-item class="difficulty" label="心理困扰" v-if="data.parameter">
        <el-checkbox-group
          :max="3"
          style="position: relative"
          v-model="data.parameter.psyDifficulty"
          :disabled="true"
        >
          <el-checkbox label="1" name="type">自杀伤人倾向</el-checkbox>
          <el-checkbox label="2" name="type">重性精神病</el-checkbox>
          <el-checkbox label="3" name="type">应激危机</el-checkbox>
          <el-checkbox label="4" name="type">人格问题</el-checkbox>
          <el-checkbox label="5" name="type">情绪障碍</el-checkbox>
          <el-checkbox label="6" name="type">成瘾行为</el-checkbox>
          <el-checkbox label="7" name="type">进食问题</el-checkbox>
          <el-checkbox label="8" name="type">睡眠问题</el-checkbox>
          <el-form-item label="其他" label-width="60px" style="display: inline-block;">
            <el-input style="width: 200px;" v-model="data.parameter.psyDifficultyOther" maxlength="30" show-word-limit :disabled="true"></el-input>
          </el-form-item>
        </el-checkbox-group>
      </el-form-item>

      <h2 style="font-size: 20px;padding-bottom: 20px">问题备注及应对工作（ <i style="color: red">*</i> 为必填项）</h2>

      <el-form-item class="cpwjzt" v-if="data.parameter" style="display: block; width: 100%;">
        <template slot="label">
          <span><i style="color: red">*</i> 初评危机状态</span>
        </template>
        <el-radio v-model="data.parameter.firstCrisis" label="1" :disabled="!firstCrisisEditable">红色预警</el-radio>
        <el-radio v-model="data.parameter.firstCrisis" label="2" :disabled="!firstCrisisEditable">橙色预警</el-radio>
        <el-radio v-model="data.parameter.firstCrisis" label="3" :disabled="!firstCrisisEditable">黄色预警</el-radio>
        <el-radio v-model="data.parameter.firstCrisis" label="4" :disabled="!firstCrisisEditable">蓝色预警</el-radio>
        <el-radio v-model="data.parameter.firstCrisis" label="5" :disabled="!firstCrisisEditable">绿色预警</el-radio>
        <el-radio v-model="data.parameter.firstCrisis" label="6" :disabled="!firstCrisisEditable">无法确定</el-radio>
      </el-form-item>

      <!-- 审核内容输入框（按角色显示，编辑者可写，其它角色只读） -->
      <!-- 风险监控员审核内容 -->
      <el-form-item v-if="showRiskMonitorReview" label="风险监控员审核内容" class="nkjs" style="display: block; width: 100%;">
        <el-input 
          type="textarea" 
          v-model="riskMonitorReviewDetail" 
          :disabled="disabledRiskMonitorReview"
          :placeholder="disabledRiskMonitorReview ? '' : '请输入风险监控员审核内容'">
        </el-input>
      </el-form-item>
      
      <!-- 危机主管审核内容 -->
      <el-form-item v-if="showCriAdminReview" label="危机主管审核内容" class="nkjs" style="display: block; width: 100%;">
        <el-input 
          type="textarea" 
          v-model="criAdminReviewDetail" 
          :disabled="disabledCriAdminReview"
          :placeholder="disabledCriAdminReview ? '' : '请输入危机主管审核内容'">
        </el-input>
      </el-form-item>
      
      <!-- 中心主任审核内容 -->
      <el-form-item v-if="showCenterDirectorReview" label="中心主任审核内容" class="nkjs" style="display: block; width: 100%;">
        <el-input 
          type="textarea" 
          v-model="centerDirectorReviewDetail" 
          :disabled="disabledCenterDirectorReview"
          :placeholder="disabledCenterDirectorReview ? '' : '请输入中心主任审核内容'">
        </el-input>
      </el-form-item>

      <!-- 办理内容输入框 -->
      <!-- type=2时：1068和1069可以看到两个输入框，但只能编辑自己的内容，另一个是查看显示 -->
      <!-- type不传值时：1068、1069、1070可以看到两个输入框，有内容就显示，没有就隐藏，都是只读 -->
      
      <!-- 危机主管办理内容 -->
      <el-form-item v-if="showCrisisAdminHandleContentDisplay" label="危机主管办理内容" class="nkjs" style="display: block; width: 100%;">
        <el-input 
          type="textarea" 
          v-model="criAdminHandleDetail" 
          :disabled="!canEditCrisisAdminHandleContent"
          :placeholder="canEditCrisisAdminHandleContent ? '请输入危机主管办理内容' : ''" >
        </el-input>
      </el-form-item>
      
      <!-- 风险监控员办理内容 -->
      <el-form-item v-if="showRiskMonitorHandleContentDisplay" label="风险监控员办理内容" class="nkjs" style="display: block; width: 100%;">
        <el-input 
          type="textarea" 
          v-model="riskMonitorHandleDetail" 
          :disabled="!canEditRiskMonitorHandleContent"
          :placeholder="canEditRiskMonitorHandleContent ? '请输入风险监控员办理内容' : ''" >
        </el-input>
      </el-form-item>
      
      <!-- 办理提交按钮（type=2时显示） -->
      <div v-if="showHandleSubmitBtn" style="text-align: center; margin-top: 20px; margin-bottom: 20px;">
        <el-button type="primary" @click="handleHandleSubmit()">确认</el-button>
      </div>
      
      <!-- 按钮区域 -->
      <div style="text-align: center; margin-top: 20px; margin-bottom: 20px;">
        <!-- 1063: 只显示提交按钮 -->
        <el-button v-if="showSubmitBtn" type="primary" @click="handleSubmit('1')">提交</el-button>
        
        <!-- 1069、1068、1070: 显示提交和驳回按钮 -->
        <template v-if="showSubmitAndRejectBtns">
          <!-- 1068 + 初评「无法确定」：仅驳回 + 提交咨询主管（与 Crisis_lookreport 一致） -->
          <template v-if="showCrisisAdminConsultDirectorBtns">
            <el-button type="danger" @click="handleReject">驳回</el-button>
            <el-button type="primary" @click="handleSubmit('4')" style="margin-left: 30px;">提交咨询主管</el-button>
          </template>
          <template v-else>
            <el-button type="danger" @click="handleReject">驳回</el-button>
            <el-button type="primary" @click="handleSubmit('1')" style="margin-left: 30px;">{{ auditPrimarySubmitText }}</el-button>
          </template>
        </template>
      
        <!-- 1068: 显示审核确认（初评非「无法确定」时） -->
        <el-button v-if="showFinalSubmitBtn" type="success" @click="handleSubmit('2')" style="margin-left: 30px;">审核确认</el-button>
      </div>

    </el-form>
    <!-- 返回按钮只在查看时显示（type不传值或为空） -->
    <div v-if="!type || type === ''" style="padding-bottom: 20px;text-align: center;">
        <el-button @click="$router.go(-1)">返回</el-button>
      </div>
    


  </div>
</template>

<script>
export default {
  data(){
    return {
      data:{
        workNo: "",
        phone: "",
        province: "",
        city: "",
        happenDate: "",
        times: "",
        isCrisis: "",
        crisiNo: "",
        totalTime: "",
        operator: "",
        qualityControl: "",
        usedPhoneOne: "",
        usedPhoneTwo: "",
        usedPhoneThree: "",
        usedPhoneFour: "",
        firstWorkNo: "",
        callNumber: "",
        knowHotline: "",
        dedicatedLine: "",
        overseasCalls: "",
        keyInformation: "",
        sex: "",
        years: "",
        degree: "",
        marriage: "",
        mainCareer: "",
        residentialStatus: "",
        personType: "",
        name: "",
        userId: "",
        trainLevel: "",
        trainID: "",
        entryDate: "",
        callType: "",
        psychotherapyHistory: "",
        psychotherapyDescribe: "",
        psychotherapyNow: "",
        mentality: "",
        chiefcomplaintType: "",
        otherLabel: "",
        medicationNow: "",
        urgentStatus: "",
        detailContent: "",
        answerPhoneRecord: "",
        referralEnd: "",
        referralResourcesOne: "",
        referralResourcesTwo: "",
        referralResourcesThree: "",
        killType: "",
        ownSuicideHistory: "",
        ownSuicideDiscribe: "",
        friendSuicideHistory: "",
        friendSuicideDiscribe: "",
        killPlan: "",
        killPlanDetail: "",
        killFeasibility: "",
        killFatality: "",
        realisticPressure: "",
        socialSupport: "",
        protectResources: "",
        secrecyThrough: "",
        callAddress: "",
        idCard: "",
        urgentContactName: "",
        urgentRelation: "",
        contactPhone: "",
        tellInformation: "",
        crisisDetail: "",
        hotLineIntervene: "",
        contactNoOne: "",
        contactResultsOne: "",
        contactNoTwo: "",
        contactResultsTwo: "",
        contactNoThree: "",
        contactResultsThree: "",
        contactNoFour: "",
        contactResultsFour: "",
        followUpType: "",
        followUpName: "",
        followUpRelation: "",
        followUpPhoneOne: "",
        followUpPhoneTwo: "",
        crisisName: "",
        parameter:{
          studyDifficulty: [],
          lifeDifficulty: [],
          contactDifficulty: [],
          developDifficulty: [],
          studyDifficultyOther: '',
          lifeDifficultyOther: '',
          contactDifficultyOther: '',
          developDifficultyOther: '',
          firstCrisis: '',
          psyDifficulty: [],
          psyDifficultyOther: '',
        }
      },
      sourceNo:'',
      type:'',
      IsIncrease:false,
      roleID: '',
      KeyNo: '',
      firstCrisisEditable: false, // 控制firstCrisis是否可编辑，默认不可编辑
      criAdminHandleDetail: '', // 危机主管办理内容（1068）
      riskMonitorHandleDetail: '', // 风险监控员办理内容（1069）
      // 审核内容（type=1）
      riskMonitorReviewDetail: '', // 风险监控员审核内容（1069）
      criAdminReviewDetail: '', // 危机主管审核内容（1068）
      centerDirectorReviewDetail: '', // 中心主任审核内容（1070）
      
    }
  },
  computed: {
    // 判断是否显示提交按钮（1063显示）
    showSubmitBtn() {
      return this.roleID && this.roleID.indexOf('1063') !== -1 && this.type === '1';
    },
    // 判断是否显示提交和驳回按钮（1069、1068、1070显示）
    showSubmitAndRejectBtns() {
      if (this.type !== '1') return false;
      const roles = ['1069', '1068', '1070'];
      return roles.some(role => this.roleID && this.roleID.indexOf(role) !== -1);
    },
    // 1068 + 审核 + 初评「无法确定」：走驳回/提交咨询主管，不显示审核确认（与 Crisis_lookreport 一致）
    showCrisisAdminConsultDirectorBtns() {
      return (
        this.type === '1' &&
        this.roleID &&
        this.roleID.indexOf('1068') !== -1 &&
        this.data &&
        this.data.parameter &&
        this.data.parameter.firstCrisis === '6'
      );
    },
    // 判断是否显示审核确认按钮（1068 显示，初评为无法确定时不显示）
    showFinalSubmitBtn() {
      return (
        this.roleID &&
        this.roleID.indexOf('1068') !== -1 &&
        this.type === '1' &&
        this.data &&
        this.data.parameter &&
        this.data.parameter.firstCrisis !== '6'
      );
    },
    // 审核(type=1)主提交按钮文案：1069=提交危机主管；1068=提交中心主任；默认=审核确认
    auditPrimarySubmitText() {
      if (!this.roleID) return '审核确认';
      if (this.roleID.indexOf('1069') !== -1) return '提交危机主管';
      if (this.roleID.indexOf('1068') !== -1) return '提交中心主任';
      return '审核确认';
    },
    // 判断是否显示危机主管办理内容输入框
    // type=2时：1068和1069都显示
    // type不传值时：1068、1069、1070显示，但需要有内容才显示
    showCrisisAdminHandleContentDisplay() {
      if (this.type === '2') {
        // type=2时，1068和1069都显示
        return (this.roleID && this.roleID.indexOf('1068') !== -1) || 
               (this.roleID && this.roleID.indexOf('1069') !== -1);
      } else if (!this.type || this.type === '') {
        // type不传值时，1068、1069、1070显示，但需要有内容才显示
        
        const hasRole = (this.roleID && this.roleID.indexOf('1068') !== -1) ||
                        (this.roleID && this.roleID.indexOf('1069') !== -1) ||
                        (this.roleID && this.roleID.indexOf('1070') !== -1);
        return hasRole && this.criAdminHandleDetail && this.criAdminHandleDetail.trim();
      }
      return false;
    },
    // 判断是否显示风险监控员办理内容输入框
    // type=2时：1068和1069都显示
    // type不传值时：1068、1069、1070显示，但需要有内容才显示
    showRiskMonitorHandleContentDisplay() {
      if (this.type === '2') {
        // type=2时，1068和1069都显示
        return (this.roleID && this.roleID.indexOf('1068') !== -1) || 
               (this.roleID && this.roleID.indexOf('1069') !== -1);
      } else if (!this.type || this.type === '') {
        // type不传值时，1068、1069、1070显示，但需要有内容才显示
        const hasRole = (this.roleID && this.roleID.indexOf('1068') !== -1) ||
                        (this.roleID && this.roleID.indexOf('1069') !== -1) ||
                        (this.roleID && this.roleID.indexOf('1070') !== -1);
        return hasRole && this.riskMonitorHandleDetail && this.riskMonitorHandleDetail.trim();
      }
      return false;
    },
    // 判断是否可以编辑危机主管办理内容（type=2时，只有1068可以编辑）
    canEditCrisisAdminHandleContent() {
      return this.type === '2' && this.roleID && this.roleID.indexOf('1068') !== -1;
    },
    // 判断是否可以编辑风险监控员办理内容（type=2时，只有1069可以编辑）
    canEditRiskMonitorHandleContent() {
      return this.type === '2' && this.roleID && this.roleID.indexOf('1069') !== -1;
    },
    // 判断是否显示办理提交按钮（type=2时，1068或1069显示）
    showHandleSubmitBtn() {
      if (this.type !== '2') return false;
      return (this.roleID && this.roleID.indexOf('1068') !== -1) || 
             (this.roleID && this.roleID.indexOf('1069') !== -1);
    },
    // 审核与查看/办理场景下三类审核内容的显示与禁用控制
    showRiskMonitorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      const isView = !this.type || (this.type !== '1' && this.type !== '2');
      const hasAuditRole = this.roleID && (this.roleID.indexOf('1069') !== -1 || this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1070') !== -1);
      const canView = this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1 || this.roleID.indexOf('1070') !== -1 || this.roleID.indexOf('1063') !== -1);
      const isHandleViewer = isHandle && this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1);
      return (isAudit && hasAuditRole) || (isView && canView) || isHandleViewer;
    },
    disabledRiskMonitorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      if (isAudit) {
        return !(this.roleID && this.roleID.indexOf('1069') !== -1);
      }
      if (isHandle) {
        return true; // 办理阶段仅查看
      }
      return true; // 查看阶段只读
    },
    showCriAdminReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      const isView = !this.type || (this.type !== '1' && this.type !== '2');
      const hasAuditRole = this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1070') !== -1);
      const canView = this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1 || this.roleID.indexOf('1070') !== -1 || this.roleID.indexOf('1063') !== -1);
      const isHandleViewer = isHandle && this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1);
      return (isAudit && hasAuditRole) || (isView && canView) || isHandleViewer;
    },
    disabledCriAdminReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      if (isAudit) {
        return !(this.roleID && this.roleID.indexOf('1068') !== -1);
      }
      if (isHandle) {
        return true; // 办理阶段仅查看
      }
      return true; // 查看阶段只读
    },
    showCenterDirectorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      const isView = !this.type || (this.type !== '1' && this.type !== '2');
      const hasAuditRole = this.roleID && (this.roleID.indexOf('1070') !== -1);
      const canView = this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1 || this.roleID.indexOf('1070') !== -1 || this.roleID.indexOf('1063') !== -1);
      const isHandleViewer = isHandle && this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1);
      return (isAudit && hasAuditRole) || (isView && canView) || isHandleViewer;
    },
    disabledCenterDirectorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      if (isAudit) {
        return !(this.roleID && this.roleID.indexOf('1070') !== -1);
      }
      if (isHandle) {
        return true; // 办理阶段仅查看
      }
      return true; // 查看阶段只读
    },
  },
  mounted() {
    // 获取角色ID
    this.roleID = sessionStorage.getItem("RoleID");
    
    if(this.$route.query.sourceNo){
      this.IsIncrease=false;
      this.sourceNo = [this.$route.query.sourceNo][0];
      this.type = this.$route.query.type || '';
      this.KeyNo = [this.$route.query.KeyNo];
      
      // 审核(type=1)时：1063、1069、1068、1070 可编辑
      const editableRoleIDs = ['1063', '1069', '1068', '1070'];
      const hasEditableRole = editableRoleIDs.some(role => this.roleID && this.roleID.indexOf(role) !== -1);
      this.firstCrisisEditable = this.type === '1' && hasEditableRole;
      
      this.$Http_Post('hotline/hotlineReport/getInfo/'+this.sourceNo, ).then((res) => {
        if (res.Code == 0) {
          this.data = res.Data;
          // 获取办理内容（如果接口返回了这些字段）
          if (res.Data.parameter.CriAdminHandleDetail !== undefined) {
            this.criAdminHandleDetail = res.Data.parameter.CriAdminHandleDetail || '';
          }
          if (res.Data.parameter.RiskMonitorHandleDetail !== undefined) {
            this.riskMonitorHandleDetail = res.Data.parameter.RiskMonitorHandleDetail || '';
          }
          // 回显审核内容（若接口返回）
          if (res.Data.parameter.RiskMonitorReviewDetail !== undefined) {
            this.riskMonitorReviewDetail = res.Data.parameter.RiskMonitorReviewDetail || '';
          }
          if (res.Data.parameter.CriAdminReviewDetail !== undefined) {
            this.criAdminReviewDetail = res.Data.parameter.CriAdminReviewDetail || '';
          }
          if (res.Data.parameter.CenterDirectorReviewDetail !== undefined) {
            this.centerDirectorReviewDetail = res.Data.parameter.CenterDirectorReviewDetail || '';
          }
        }
      });
    }else{
      this.IsIncrease=true;
    }
  },
  methods:{
    validateNumber(event, field) {
      if (!event || !event.target) {
        return; // 确保 event.target 存在
      }

      const value = event.target.value;
      const numericValue = value.replace(/[^0-9]/g, ''); // 过滤非数字字符

      // 更新 ruleForm 中的相应字段
      this.data[field] = numericValue ? Number(numericValue) : null; // 转换为数字或设置为 null
    },
    querySearch(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }

      this.$Http_Post('/User/throughConditionGetUserList', { pageSize: 100, pageIndex: 1, phone: queryString }).then((res) => {
        const SUCCESS_CODES = [0, 200];
        if (SUCCESS_CODES.includes(res.Code)) {
          var restaurants = res.Data || [];
          if (restaurants.length > 0) {
            var results = restaurants.filter(this.createFilter(queryString));
            cb(results);
          } else {
            cb([]);
          }
        }
      });
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.Phone && restaurant.Phone.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      //this.data.workNo=item.UserID;
      this.data.phone = item.Phone;
      this.data.name = item.RealName;
      this.data.userId = item.UserID;
      this.data.sex = item.Sex==1?'男':'女';
      this.data.years = item.Years;
      this.data.degree = item.Degree;
      this.data.marriage = item.Marriage;
      this.data.trainID = item.TrainName;
      this.data.entryDate = item.EntryDate;
      this.data.province = item.Province;
      this.data.city = item.City;
      this.data.idCard = item.IDCard;
    },
    Increase(){
      if(this.data.parameter.firstCrisis==""){
        this.$message.error('请选择初评危机状态');
        return false
      }
      if(!this.data.workNo || this.data.workNo.trim() === ""){
        this.$message.error('请输入连接工单编号');
        return false
      }
      if(!this.data.phone || this.data.phone.trim() === ""){
        this.$message.error('请输入来电号码');
        return false
      }
      if(!this.data.userId || this.data.userId.trim() === ""){
        this.$message.error('请输入学号');
        return false
      }
      this.Increaseloading=true;
      this.$Http_Post('/hotline/hotlineReport/add',this.data).then(res=>{
        this.Increaseloading=false;
        if(res.Code==0 || res.Code==200){
          this.$message.success(res.Message);
          this.data=this.$options.data().data
        }else{
          this.$message.error(res.Message);
        }
      })
    },
    // 驳回处理（带确认提示）
    handleReject() {
      this.$confirm('确认驳回该申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleSubmit('0');
      }).catch(() => {
        // 用户取消操作
      });
    },
    // 提交/驳回处理
    handleSubmit(type) {
      // type: '0' 驳回, '1' 提交（按角色主流程）, '2' 审核确认(1068), '4' 提交咨询主管(1068+无法确定)
      // 验证 KeyNo
      if (!this.KeyNo|| !this.KeyNo[0]) {
        this.$message.warning('缺少关键参数');
        return;
      }
      
      // 构建请求参数
      const params = {
        keyNo: this.KeyNo[0],
        type: type, // 提交驳回标记
        sourceFlg: "5",//5：热线上报
      };
      
      // 根据角色决定是否传初评危机状态
      const editableRoles = ['1063', '1069', '1068', '1070'];
      const canEdit = editableRoles.some(role => this.roleID && this.roleID.indexOf(role) !== -1);
      
      if (canEdit) {
        // 1063、1069、1068 传初评危机状态
        if (!this.data.parameter.firstCrisis || this.data.parameter.firstCrisis == '0') {
          this.$message.warning('请选择初评危机状态');
          return;
        }
        params.firstCrisis = this.data.parameter.firstCrisis;
      }
      
      // 审核(type=1)时附带对应角色的审核内容（若填写）
      if (this.type === '1') {
        if (this.roleID && this.roleID.indexOf('1069') !== -1 && this.riskMonitorReviewDetail && this.riskMonitorReviewDetail.trim()) {
          params.RiskMonitorReviewDetail = this.riskMonitorReviewDetail.trim();
        }
        if (this.roleID && this.roleID.indexOf('1068') !== -1 && this.criAdminReviewDetail && this.criAdminReviewDetail.trim()) {
          params.CriAdminReviewDetail = this.criAdminReviewDetail.trim();
        }
        if (this.roleID && this.roleID.indexOf('1070') !== -1 && this.centerDirectorReviewDetail && this.centerDirectorReviewDetail.trim()) {
          params.CenterDirectorReviewDetail = this.centerDirectorReviewDetail.trim();
        }
      }
      
      this.$Http_Post('/DistressPrediction/UpdateFirstCrisis', params).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message.success(res.Message || '操作成功');
          // 可以返回上一页或刷新数据
          this.$router.go(-1);
        } else {
          this.$message.error(res.Message || '操作失败');
        }
      }).catch((err) => {
        this.$message.error('操作失败');
      });
    },
    // 办理提交处理（type=2时使用）
    handleHandleSubmit() {
      // 验证 sourceNo
      if (!this.KeyNo|| !this.KeyNo[0]) {
        this.$message.warning('缺少关键参数');
        return;
      }
      
      // 构建请求参数
      const params = {
        keyNo: this.KeyNo[0],
        type: '2', // 办理标记
      };
      
      // 根据角色添加不同的办理内容字段
      if (this.roleID && this.roleID.indexOf('1068') !== -1) {
        // 1068: 危机主管办理内容
        if (!this.criAdminHandleDetail || !this.criAdminHandleDetail.trim()) {
          this.$message.warning('请输入危机主管办理内容');
          return;
        }
        params.criAdminHandleDetail = this.criAdminHandleDetail.trim();
      } else if (this.roleID && this.roleID.indexOf('1069') !== -1) {
        // 1069: 风险监控员办理内容
        if (!this.riskMonitorHandleDetail || !this.riskMonitorHandleDetail.trim()) {
          this.$message.warning('请输入风险监控员办理内容');
          return;
        }
        params.riskMonitorHandleDetail = this.riskMonitorHandleDetail.trim();
      }
      
      this.$Http_Post('/DistressPrediction/HandleCrisis', params).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message.success(res.Message || '办理提交成功');
          // 可以返回上一页或刷新数据
          this.$router.go(-1);
        } else {
          this.$message.error(res.Message || '办理提交失败');
        }
      }).catch((err) => {
        this.$message.error('办理提交失败');
      });
    }
  },

}
</script>

<style>
.Hot_wire {width: 100%;height: 100%;background-color: #fff;overflow: auto;}
/* .Hot_wire .el-form-item{width: 24%;} */
.Hot_wire .el-form--inline .el-form-item__label{width: 150px;}
.Hot_wire .el-form--inline .el-form-item__content{width: calc(100% - 150px);}
/* .Hot_wire .qw{width: 48%;} */
.Hot_wire .qw .el-form-item__content{width: 500px;}
.Hot_wire .bgfbf2{width: 1020px;}

.Hot_wire .nkjs .el-form-item__content{width: 600px !important;}
.Hot_wire .nkjs .el-textarea.is-disabled .el-textarea__inner{width: 500px !important;height: 80px;}
.Hot_wire .nkjs .el-textarea .el-textarea__inner{width: 500px !important;height: 80px;}
.Hot_wire .cpwjzt{display: block !important; width: 100% !important;}
.Hot_wire .cpwjzt .el-form-item__content{margin-left: 0 !important;}
</style>